import React, { Component } from "react";
import PropTypes from "prop-types";
import MaskedInput from "react-text-mask";
import classNames from "classnames";
import utils from "@utils";
import { JobService, AssignmentRulesService, OrganizationFavoriteGroupsService } from "@services";
import { AUTO_APPROVAL_TYPES, DAYS_OF_WEEK, ORDER_OF_SENIORITY } from "@constants";
import ReactSelect from "../ReactSelect/ReactSelect";
import Modal from "../Modal/Modal";
import Tooltip from "../Tooltip/Tooltip";
import TimeInput from "../TimeInput/TimeInput";
import "./PostJobModal.scss";

class PostJobModal extends Component {
	constructor(props) {
		super(props);
		this.timesToPost = [
			{ label: "Now", value: "immediately" },
			{ label: "Based on job time", value: "basedOnJob" },
			{ label: "Specific date/time", value: "specificDate" },
		];
		this.signUpPeriodTimeTypeOptions = [
			{ label: "hours", value: 1 },
			{ label: "days", value: 24 },
		];
		const {
			FIRST_COME_FIRST_SERVED,
			MANUAL,
			SENIORITY_DESCENDING,
			SENIORITY_ASCENDING,
			BY_HOURS,
			BY_JOBS,
			RANDOM,
		} = AUTO_APPROVAL_TYPES;
		this.assignmentTypes = [
			{ label: "Manually", value: MANUAL },
			{ label: "First come first serve", value: FIRST_COME_FIRST_SERVED },
			{ label: "By hours", value: BY_HOURS },
			{ label: "By number of jobs", value: BY_JOBS },
			{ label: "Most senior", value: SENIORITY_DESCENDING },
			{ label: "Least senior", value: SENIORITY_ASCENDING },
			{ label: "Randomly ", value: RANDOM },
		];
		this.initialState = {
			signUpPeriodHoursMultiplier: 1,
			timeToPost: "immediately",
			postAt: "PostPriorByDays",
			postUsingAssignmentGroup: false,
			postUsingStaggeredPosting: false,
			postingTime: undefined,
			AssignmentGroupId: "",
			StaggeredRuleId: "",
			daysPriorForWeek: "",
			monthDayTime: undefined,
			postExactTime: undefined,
			PostedType: 0,
			PostedDelayType: "",
			OpenToAllOfficers: false,
			PostDelayInMinutes: "",
			PostedGroup: -2,
			PostPriorByDays: "",
			weekDayTime: undefined,
			PostByWeekDay: "",
			PostByMonthDay: "",
			PostExactDateTime: "",
			JobAutoAssignType: 1,
			JobAutoAssignHoursSpan: "",
			AllowJobApplicationsWhileActive: false,
			EnableFirstComeFirstServed: true,
			JobAutoAssignQueueCycleMaxAssignments: "",
			MaxHoursAssignmentPerCycle: "",
			_hoursJobsSelectedOptionValue: "",
			SeniorityOrder: null,
			_hoursJobsSelectedOption: "MaxHoursAssignmentPerCycle",
			NumberOfRounds: "",
			_limitToRoundsChecked: false,
			JobAutoAssignYearToDateSpan: false,
			JobAutoAssignJobCountDaysSpan: "",
			assignmentGroups: [],
			staggeredRules: [],
			officerGroups: [],
			setAssignmentRule: false,
			assignmentRuleName: "",
			JobAutoAssignJobCountDaysRadio: false,
			JobAutoAssignRolling365: false,
			errors: {
				AssignmentGroupId: false,
				StaggeredRuleId: false,
				PostedGroup: false,
				PostDelayInMinutes: false,
				postingTime: false,
				PostPriorByDays: false,
				PostByWeekDay: false,
				weekDayTime: false,
				daysPriorForWeek: false,
				PostByMonthDay: false,
				PostExactDateTime: false,
				monthDayTime: false,
				postExactTime: false,
				JobAutoAssignHoursSpan: false,
				SeniorityOrder: false,
				JobAutoAssignJobCountDaysSpan: false,
				MaxHoursAssignmentPerCycle: false,
			},
		};
		// create a clone of initial state in order to prevent manipulating its refrence
		this.state = JSON.parse(JSON.stringify(this.initialState));
	}

	componentDidMount() {
		const {
			organization: {
				JobAutoAssignType = 1,
				JobAutoAssignJobCountDaysSpan = "",
				JobAutoAssignYearToDateSpan = false,
				JobAutoAssignRolling365 = false,
				JobAutoAssignJobCountDaysRadio = false,
			},
		} = this.props;
		let {
			organization: { JobAutoAssignHoursSpan = "" },
		} = this.props;
		let signUpPeriodHoursMultiplier = 1;
		if (JobAutoAssignHoursSpan && JobAutoAssignHoursSpan % 24 === 0) {
			signUpPeriodHoursMultiplier = 24;
			JobAutoAssignHoursSpan = (JobAutoAssignHoursSpan / 24).toString();
		}
		this.setState({
			signUpPeriodHoursMultiplier,
			JobAutoAssignHoursSpan,
			JobAutoAssignType,
			JobAutoAssignJobCountDaysSpan,
			JobAutoAssignYearToDateSpan,
			JobAutoAssignRolling365,
			JobAutoAssignJobCountDaysRadio,
		});
	}

	/** @todo Rewrite the function calls in this lifecycle method to be called via `onEntered` */
	componentDidUpdate(prevProps) {
		const { show } = this.props;
		if (prevProps.show !== show && show) {
			this.getAssignmentRules();
			this.getOfficerGroups();
			this.getStaggeredRules();
		}
	}

	//  Service Methods
	/** Retrieves the custom assignment rules available to the current user */
	getAssignmentRules = () => {
		const { lang } = global;
		AssignmentRulesService.getAll()
			.then(({ data }) => {
				this.setState({
					assignmentGroups: data.map(({ Id: value, Name: label }) => ({ value, label })),
				});
			})
			.catch(() => {
				utils.notify({
					type: "error",
					message: lang.t("Error loading Assignment Rules"),
					title: "Error",
				});
			});
	};

	getStaggeredRules = () => {
		const { lang } = global;
		AssignmentRulesService.getStaggeredRules()
			.then(({ data }) => {
				this.setState({
					staggeredRules: data.map(({ Id: value, Name: label }) => ({ value, label })),
				});
			})
			.catch(() => {
				utils.notify({
					type: "error",
					message: lang.t("Error loading staggered Rules"),
					title: "Error",
				});
			});
	};

	/** Retrieves all officer groups accessible to the current user */
	getOfficerGroups = () => {
		const { lang } = global;
		OrganizationFavoriteGroupsService.getGroups()
			.then(({ data }) => {
				const officerGroups = data.map(({ Id: value, Name: label }) => ({ value, label }));
				officerGroups.unshift(
					{ value: -2, label: '"Entire department"' },
					{ value: -1, label: '"All officer groups"' },
				);
				this.setState({ officerGroups });
			})
			.catch(() => {
				utils.notify({
					type: "error",
					message: lang.t("Error getting Officer Groups"),
					title: "Error",
				});
			});
	};

	/** Combine date and time into a string to be sent to the API */
	formatDateTime = (date, time) => {
		const formattedDate = utils.isIOSDevice
			? date.replace(/-/gi, "/")
			: utils.fixIELocaleString(date);
		let dateTime = "";
		if (time.includes(":")) {
			dateTime = `${formattedDate}T${time}`;
		} else {
			dateTime = `${formattedDate}T${time}:00.000`;
		}
		return dateTime;
	};

	/** Makes an API request to post the current job (or job series) with the selected parameters if the form is determined to be in a valid state */
	postJob = () => {
		const { lang } = global;
		const { updateAllUpcoming, selectedJobs, successCallback } = this.props;
		const {
			postAt,
			timeToPost,
			postingTime,
			weekDayTime,
			monthDayTime,
			postExactTime,
			daysPriorForWeek,
			postUsingAssignmentGroup,
			postUsingStaggeredPosting,
			AssignmentGroupId,
			PostedGroup,
			PostPriorByDays,
			PostTimeInMinutes,
			PostByWeekDay,
			PostedDelayType,
			StaggeredRuleId,
			PostByMonthDay,
			PostExactDateTime,
			PostDelayInMinutes,
			PostedType,
			signUpPeriodHoursMultiplier,
			JobAutoAssignHoursSpan,
			JobAutoAssignJobCountDaysSpan,
			JobAutoAssignType,
			JobAutoAssignYearToDateSpan,
			EnableFirstComeFirstServed,
			JobAutoAssignRolling365,
			JobAutoAssignJobCountDaysRadio,
			AllowJobApplicationsWhileActive,
		} = this.state;
		const { MANUAL, BY_HOURS, BY_JOBS } = AUTO_APPROVAL_TYPES;
		//  change data params if user chooses an assignment rule
		let dataParams = !postUsingAssignmentGroup
			? {
					PostedGroup: PostedType === 2 ? PostedGroup : null,
					PostTimeInMinutes,
					PostByMonthDay,
					PostExactDateTime,
					PostByWeekDay,
					JobAutoAssignHoursSpan,
					JobAutoAssignJobCountDaysSpan,
					JobAutoAssignType,
					JobAutoAssignYearToDateSpan:
						JobAutoAssignType === BY_HOURS || JobAutoAssignType === BY_JOBS
							? JobAutoAssignYearToDateSpan
							: false,
					JobAutoAssignRolling365:
						(JobAutoAssignType === BY_HOURS || JobAutoAssignType === BY_JOBS) &&
						JobAutoAssignRolling365 != null
							? JobAutoAssignRolling365
							: false,
					JobAutoAssignJobCountDaysRadio,
					StaggeredAssignmentRuleId: StaggeredRuleId,
					PostedDelayType,
					PostDelayInMinutes,
					PostedType,
					PostPriorByDays,
					Posted: true,
					KeepOriginalBehaviorForAutoAssign:
						EnableFirstComeFirstServed && JobAutoAssignType !== MANUAL,
					AllowJobApplicationsWhileActive,
				}
			: {
					AssignmentGroupId,
					Posted: true,
					KeepOriginalBehaviorForAutoAssign:
						EnableFirstComeFirstServed && JobAutoAssignType !== MANUAL,
					AllowJobApplicationsWhileActive,
				};
		if (postUsingStaggeredPosting) {
			dataParams = {
				JobAutoAssignType: 0,
				StaggeredAssignmentRuleId: StaggeredRuleId,
				Posted: true,
			};
		}

		const queryParams = {
			updateAllUpcoming,
			id: selectedJobs[0].Id,
		};
		if (JobAutoAssignType === 2) {
			dataParams.JobAutoAssignJobCountDaysSpan = "";
			dataParams.JobAutoAssignHoursSpan = "";
		}
		const validation = this.validateForm();
		if (PostedDelayType === 1)
			dataParams.PostDelayInMinutes = parseInt(PostDelayInMinutes, 10) * 60;
		if (timeToPost === "specificDate" || timeToPost === "basedOnJob") {
			switch (postAt) {
				case "PostPriorByDays":
					dataParams.PostTimeInMinutes = utils.convertTimeToMinutes(postingTime);
					dataParams.PostPriorByDays = parseInt(PostPriorByDays, 10);
					break;
				case "PostByWeekDay":
					dataParams.PostByWeekDay = parseInt(PostByWeekDay, 10);
					dataParams.PostTimeInMinutes = utils.convertTimeToMinutes(weekDayTime);
					dataParams.PostPriorByDays = parseInt(daysPriorForWeek, 10);
					break;
				case "PostByMonthDay":
					dataParams.PostByMonthDay = parseInt(PostByMonthDay, 10);
					dataParams.PostTimeInMinutes = utils.convertTimeToMinutes(monthDayTime);
					break;
				case "PostExactDateTime":
					dataParams.PostExactDateTime = this.formatDateTime(
						PostExactDateTime,
						postExactTime,
					);
					break;
				default:
					break;
			}
		}

		// if the sign up period is in days, calculate the equivalent hours
		if (parseInt(signUpPeriodHoursMultiplier, 10) === 24) {
			dataParams.JobAutoAssignHoursSpan = JobAutoAssignHoursSpan * 24;
		}
		// check if form fields are valid before making request
		if (validation.isValid) {
			// Posting a job from Job List
			if (selectedJobs.length > 1) {
				//  selectedJobs list of selected jobs from the job list
				const JobEventIds = selectedJobs.map(job => job.Id);
				JobService.postMultipleJobs(undefined, { ...dataParams, JobEventIds })
					.then(() => {
						utils.notify({
							type: "success",
							message: lang.t("Job posted successfully"),
						});
						this.closeModal();
						successCallback();
					})
					.catch(() => {
						utils.notify({
							type: "error",
							message: lang.t("Error posting Job"),
							title: "Error",
						});
					});
			} else {
				// Posting a job from Job Details
				JobService.postJob(queryParams, dataParams)
					.then(() => {
						utils.notify({
							type: "success",
							message: lang.t("Job posted successfully"),
						});
						this.closeModal();
						successCallback();
					})
					.catch(() => {
						utils.notify({
							type: "error",
							message: lang.t("Error posting Job"),
							title: "Error",
						});
					});
			}
		}
	};

	/** Makes an API request to save a new assignment rule for the current user's agency provided all fields are in a valid state */
	onSaveAssigmentRule = () => {
		const { lang } = global;
		const {
			JobAutoAssignHoursSpan,
			JobAutoAssignQueueCycleMaxAssignments,
			MaxHoursAssignmentPerCycle,
			SeniorityOrder,
			_hoursJobsSelectedOption,
			_limitToRoundsChecked,
			NumberOfRounds,
			JobAutoAssignJobCountDaysSpan,
			JobAutoAssignType,
			JobAutoAssignYearToDateSpan,
			JobAutoAssignRolling365,
			JobAutoAssignJobCountDaysRadio,
			PostTimeInMinutes,
			PostDelayInMinutes,
			PostedDelayType,
			PostedGroup,
			PostedType,
			PostPriorByDays,
			PostByWeekDay,
			PostByMonthDay,
			PostExactDateTime,
			postAt,
			daysPriorForWeek,
			assignmentRuleName,
			timeToPost,
			postingTime,
			weekDayTime,
			monthDayTime,
			postExactTime,
			signUpPeriodHoursMultiplier,
			EnableFirstComeFirstServed,
			_hoursJobsSelectedOptionValue,
		} = this.state;

		const { FIRST_COME_FIRST_SERVED, MANUAL, BY_HOURS, BY_JOBS } = AUTO_APPROVAL_TYPES;

		const dataParams = {
			Name: assignmentRuleName,
			PostPriorByDays: postAt === "PostByWeek" ? daysPriorForWeek : PostPriorByDays,
			AssignmentGroupType: 0,
			KeepOriginalBehaviorForAutoAssign:
				EnableFirstComeFirstServed &&
				JobAutoAssignType !== MANUAL &&
				JobAutoAssignType !== FIRST_COME_FIRST_SERVED,
			JobAutoAssignHoursSpan,
			SeniorityOrder,
			JobAutoAssignQueueCycleMaxAssignments,
			MaxHoursAssignmentPerCycle,
			JobAutoAssignJobCountDaysSpan,
			JobAutoAssignType,
			JobAutoAssignYearToDateSpan:
				JobAutoAssignType === BY_HOURS || JobAutoAssignType === BY_JOBS
					? JobAutoAssignYearToDateSpan
					: false,
			JobAutoAssignRolling365:
				(JobAutoAssignType === BY_HOURS || JobAutoAssignType === BY_JOBS) &&
				JobAutoAssignRolling365 != null
					? JobAutoAssignRolling365
					: false,
			JobAutoAssignJobCountDaysRadio,
			PostTimeInMinutes,
			PostDelayInMinutes,
			PostedDelayType,
			PostedGroup: PostedType === 2 ? PostedGroup : null,
			PostedType,
			PostByWeekDay,
			PostByMonthDay,
			PostExactDateTime,
			NumberOfRounds,
		};

		if (PostedDelayType === 1)
			dataParams.PostDelayInMinutes = parseInt(PostDelayInMinutes, 10) * 60;
		if (timeToPost === "basedOnJob") {
			switch (postAt) {
				case "PostPriorByDays":
					dataParams.PostTimeInMinutes = utils.convertTimeToMinutes(postingTime);
					dataParams.PostPriorByDays = parseInt(PostPriorByDays, 10);
					break;
				case "PostByWeekDay":
					dataParams.PostByWeekDay = parseInt(PostByWeekDay, 10);
					dataParams.PostTimeInMinutes = utils.convertTimeToMinutes(weekDayTime);
					dataParams.PostPriorByDays = parseInt(daysPriorForWeek, 10);
					break;
				case "PostByMonthDay":
					dataParams.PostByMonthDay = parseInt(PostByMonthDay, 10);
					dataParams.PostTimeInMinutes = utils.convertTimeToMinutes(monthDayTime);
					break;
				default:
					break;
			}
		} else if (timeToPost === "specificDate") {
			dataParams.PostExactDateTime = this.formatDateTime(PostExactDateTime, postExactTime);
		}

		// if the sign up period is in days, calculate the equivalent hours
		if (parseInt(signUpPeriodHoursMultiplier, 10) === 24) {
			dataParams.JobAutoAssignHoursSpan = JobAutoAssignHoursSpan * 24;
		}
		let auxSeniorityOrder = null;
		if (JobAutoAssignType === 5) {
			auxSeniorityOrder = 1;
		}
		if (JobAutoAssignType === 6) {
			auxSeniorityOrder = 2;
		}
		if (SeniorityOrder) {
			dataParams.SeniorityOrder = SeniorityOrder;
		} else {
			dataParams.SeniorityOrder = auxSeniorityOrder;
		}
		if (_hoursJobsSelectedOption) {
			switch (_hoursJobsSelectedOption) {
				case "JobAutoAssignQueueCycleMaxAssignments":
					dataParams.JobAutoAssignQueueCycleMaxAssignments = parseInt(
						_hoursJobsSelectedOptionValue,
						10,
					);
					dataParams.MaxHoursAssignmentPerCycle = null;
					break;
				case "MaxHoursAssignmentPerCycle":
					dataParams.MaxHoursAssignmentPerCycle = parseInt(
						_hoursJobsSelectedOptionValue,
						10,
					);
					dataParams.JobAutoAssignQueueCycleMaxAssignments = null;
					break;
				default:
					break;
			}
		}
		if (_limitToRoundsChecked && NumberOfRounds) {
			dataParams.NumberOfRounds = parseInt(NumberOfRounds, 10);
		}
		const validation = this.validateForm();
		// check if form fields are valid before making request
		if (validation.isValid) {
			AssignmentRulesService.create(null, { ...dataParams })
				.then(() => {
					utils.notify({
						type: "success",
						message: lang.t("Assignment rule created successfully"),
						title: lang.t("Success"),
					});
					this.setState({ ...this.initialState }, () => {
						this.getAssignmentRules();
						this.getOfficerGroups();
					});
				})
				.catch(() => {
					utils.notify({
						type: "error",
						message: lang.t("Error creating Assignment Rule"),
						title: "Error",
					});
				});
		}
	};
	//  Service Methods

	/**
	 * Handles changes to all radio buttons in this modal
	 * @param {Event} e The HTML event handled by this method
	 */
	handleRadioChange = e => {
		const {
			target: { name, value, id },
		} = e;
		let newValue = value;
		// clear conditional input values when toggling radio inputs
		if (name === "postUsingAssignmentGroup" && value === "false") {
			this.setState({ AssignmentGroupId: "" });
		}
		if (name === "postUsingStaggeredPosting" && value === "false") {
			this.setState({ StaggeredRuleId: "" });
		}
		if (name === "PostedType" && (parseInt(value, 10) === 0 || parseInt(value, 10) === 1)) {
			this.setState({
				PostedGroup: "",
				PostedDelayType: "",
				PostDelayInMinutes: "",
			});
		} else if (name === "PostedType" && parseInt(value, 10) === 2) {
			this.setState({ PostedDelayType: 0 });
		}
		if (
			name === "PostedDelayType" &&
			(parseInt(value, 10) === 0 || parseInt(value, 10) === 2)
		) {
			this.setState({ PostDelayInMinutes: "" });
		}
		if (name === "timeToPost" && value === "immediately") {
			this.setState({
				postAt: "",
				postingTime: "",
				PostPriorByDays: "",
				PostByWeekDay: "",
				PostExactDateTime: "",
				weekDayTime: "",
				daysPriorForWeek: "",
				PostByMonthDay: "",
				monthDayTime: "",
				postExactTime: "",
			});
		}

		if (name === "postAt") {
			this.postAtResetState(value);
		}
		if (name === "JobAutoAssignType" || name === "PostedType" || name === "PostedDelayType")
			newValue = parseInt(value, 10);
		if (
			name === "JobAutoAssignYearToDateSpan" ||
			name === "postUsingAssignmentGroup" ||
			name === "postUsingStaggeredPosting"
		) {
			const parsedId = id.substring(0, id.indexOf("-"));
			switch (parsedId) {
				case "JobAutoAssignRolling365":
					this.setState({
						JobAutoAssignYearToDateSpan: false,
						JobAutoAssignRolling365: value === "true",
						JobAutoAssignJobCountDaysRadio: false,
						JobAutoAssignJobCountDaysSpan: "",
					});
					return;
				case "JobAutoAssignJobCountDaysRadio":
					this.setState({
						JobAutoAssignYearToDateSpan: false,
						JobAutoAssignRolling365: false,
						JobAutoAssignJobCountDaysRadio: value === "true",
						JobAutoAssignJobCountDaysSpan: "",
					});
					return;
				case "postUsingAssignmentGroup":
					this.setState({
						postUsingAssignmentGroup: value === "true",
						JobAutoAssignYearToDateSpan: false,
						JobAutoAssignRolling365: false,
						JobAutoAssignJobCountDaysRadio: false,
						postUsingStaggeredPosting: false,
						JobAutoAssignJobCountDaysSpan: "",
					});
					return;
				case "postUsingStaggeredPosting":
					this.setState({
						postUsingStaggeredPosting: value === "true",
						JobAutoAssignYearToDateSpan: false,
						JobAutoAssignRolling365: false,
						JobAutoAssignJobCountDaysRadio: false,
						postUsingAssignmentGroup: false,
						JobAutoAssignJobCountDaysSpan: "",
					});
					return;
				default:
					this.setState({
						JobAutoAssignYearToDateSpan: value === "true",
						JobAutoAssignRolling365: false,
						JobAutoAssignJobCountDaysRadio: false,
						JobAutoAssignJobCountDaysSpan: "",
					});
					return;
			}
		}

		this.setState({ [name]: newValue });
	};

	/**
	 * Reset selected data, about to avoid non relate values of radio button.
	 * @param {string} value
	 * @param {string} [field]
	 */
	postAtResetState = (value, field) => {
		const postAtState = {
			PostByWeekDay: "",
			weekDayTime: "",
			daysPriorForWeek: "",
			PostByMonthDay: "",
			PostExactDateTime: "",
			monthDayTime: "",
			postExactTime: "",
			PostPriorByDays: "",
			postingTime: "",
		};
		delete postAtState[value];

		this.setState(
			{
				...postAtState,
			},
			() => {
				if (field) {
					this.setState({ [field]: value });
				}
			},
		);
	};

	changeDate =
		property =>
		({ target: { value, min, max } }) => {
			const formattedValue = utils.isIOSDevice ? value.replace(/\//gi, "-") : value;

			if (property === "PostExactDateTime" && formattedValue !== "") {
				const { selectedJobs } = this.props;
				const { postExactTime, errors, setAssignmentRule } = this.state;
				const jobStartTime = utils.formatTime(
					new Date(`${selectedJobs[0]?.StartDateTime}Z`),
					true,
					selectedJobs[0]?.TimeZoneId,
				);
				const timeLimit = utils.addSubtractTime(
					selectedJobs[0]?.StartDateTime,
					jobStartTime,
					15,
					false,
				);
				const minStartDate = utils.formatDate();
				let time = postExactTime;

				let errorObj = {
					errors: {
						...errors,
						postExactTime: false,
						PostExactDateTime: false,
					},
				};

				if (formattedValue < min) {
					errorObj = {
						errors: {
							PostExactDateTime: true,
						},
					};
				}

				if (formattedValue > max && !setAssignmentRule) {
					errorObj = {
						errors: {
							PostExactDateTime: true,
						},
					};
				}

				if (formattedValue === minStartDate) {
					time = utils.formatTime(undefined, false, selectedJobs[0]?.TimeZoneId);
				}

				if (formattedValue === max && !setAssignmentRule) {
					time = timeLimit;
				}

				this.setState(() => ({
					PostExactDateTime: formattedValue,
					postExactTime: time,
					...errorObj,
				}));

				return;
			}

			this.setState({ [property]: formattedValue });
		};

	getAssignmentRuleData = id => {
		const { assignmentGroups } = this.state;
		AssignmentRulesService.getById(id)
			.then(({ data }) => {
				const auxGroup = [...assignmentGroups];
				const idx = auxGroup.findIndex(item => item.value === id);
				auxGroup[idx] = {
					...auxGroup[idx],
					KeepOriginalBehaviorForAutoAssign: data.KeepOriginalBehaviorForAutoAssign,
				};
				this.setState({
					assignmentGroups: auxGroup,
				});
			})
			.catch(() => {
				const { lang } = global;
				utils.notify({
					type: "error",
					message: lang.t("Error loading Assignment Rule"),
					title: "Error",
				});
			});
	};

	/**
	 * Updates values from changes to all inputs in this modal except radio buttons
	 * @param {Event} e The HTML event handled by this method
	 * @param {String} property The name of the property to update
	 */
	handleInputChange = (e, property) => {
		let value;
		let type;
		let name;
		let errorObj;
		let checked;
		const { errors } = this.state;
		if (
			property === "AssignmentGroupId" ||
			property === "PostedGroup" ||
			property === "timeToPost" ||
			property === "JobAutoAssignType" ||
			property === "StaggeredRuleId"
		) {
			value = e?.value || "";
			type = e?.type || "";
			name = e?.name || property;
			if (property === "AssignmentGroupId") {
				this.getAssignmentRuleData(value);
			}
			if (property === "PostedGroup") {
				let auxPostedType;
				if (value === -2) {
					auxPostedType = 0;
				} else if (value === -1) {
					auxPostedType = 1;
				} else {
					auxPostedType = 2;
				}
				this.setState({
					PostedType: auxPostedType,
					OpenToAllOfficers: false,
					PostedDelayType: null,
					PostDelayInMinutes: "",
				});
			}
			if (
				property === "JobAutoAssignType" &&
				(parseInt(value, 10) === 1 || parseInt(value, 10) === 2)
			) {
				this.setState({
					JobAutoAssignHoursSpan: "",
					signUpPeriodHoursMultiplier: 1,
					JobAutoAssignJobCountDaysSpan: "",
					JobAutoAssignYearToDateSpan: false,
					JobAutoAssignRolling365: false,
					JobAutoAssignJobCountDaysRadio: false,
					NumberOfRounds: "",
					_limitToRoundsChecked: false,
					errors: {
						NumberOfRounds: false,
					},
				});
			} else if (property === "JobAutoAssignType") {
				this.setState({
					JobAutoAssignHoursSpan: "",
					signUpPeriodHoursMultiplier: 1,
					JobAutoAssignQueueCycleMaxAssignments: "",
					MaxHoursAssignmentPerCycle: "",
					NumberOfRounds: "",
					JobAutoAssignJobCountDaysSpan: "",
					_limitToRoundsChecked: false,
					_hoursJobsSelectedOption: "MaxHoursAssignmentPerCycle",
					errors: {
						NumberOfRounds: false,
					},
				});
			}
		} else {
			({
				target: { value, type, name, checked },
			} = e);
		}

		if (type === "tel") {
			value = value.replace(/\D/g, "");
		}

		if (type === "time" && name === "postExactTime") {
			const { max, min } = e.target;
			errorObj = {
				errors: {
					...errors,
					postExactTime: errors.PostExactDateTime,
				},
			};

			if (max !== "" && (value > max || value === "")) {
				errorObj = {
					errors: {
						...errors,
						postExactTime: true,
					},
				};
			}

			if (min !== "" && value < min && value !== max) {
				errorObj = {
					errors: {
						...errors,
						postExactTime: true,
					},
				};
			}
		}

		if (type === "checkbox") {
			value = checked;
			if (property === "OpenToAllOfficers") {
				if (!checked) {
					this.setState({ PostedDelayType: 0 });
				}
			}
		}

		if (name === "_limitToRoundsChecked") {
			value = checked;

			if (!checked) {
				this.setState({
					NumberOfRounds: "",
					errors: {
						NumberOfRounds: false,
					},
				});
			}
		}

		this.setState(prevstate => ({
			...prevstate,
			[name]: value,
			...errorObj,
		}));
	};

	/**
	 * Called when unfocusing from a text input
	 * @param {Event} e The HTML event handled by this method
	 */
	handleIntegerOnBlur = e => {
		const {
			target: { value, name },
		} = e;
		// OnBlur : set values to initial state if the value is less than 1
		if (name === "PostByMonthDay" && parseInt(value, 10) > 31) {
			this.setState({ PostByMonthDay: "31" });
		}
		if (parseInt(value, 10) < 1) this.setState({ [name]: "" });
	};

	/** Resets assignment rule fields to their initial values */
	setAssignmentRule = () => {
		// reset state fileds since the same fields will be used when setting assignment rules
		this.setState({
			signUpPeriodHoursMultiplier: 1,
			timeToPost: "immediately",
			postAt: "PostPriorByDays",
			postUsingAssignmentGroup: false,
			postUsingStaggeredPosting: false,
			postingTime: "",
			AssignmentGroupId: "",
			daysPriorForWeek: "",
			monthDayTime: "",
			postExactTime: "",
			PostedType: 0,
			PostedDelayType: 0,
			PostDelayInMinutes: "",
			PostedGroup: -2,
			PostPriorByDays: "",
			weekDayTime: "",
			PostByWeekDay: "",
			PostByMonthDay: "",
			PostExactDateTime: "",
			JobAutoAssignType: 1,
			JobAutoAssignHoursSpan: "",
			JobAutoAssignYearToDateSpan: false,
			JobAutoAssignJobCountDaysSpan: "",
			setAssignmentRule: true,
			JobAutoAssignJobCountDaysRadio: false,
			JobAutoAssignRolling365: false,
			EnableFirstComeFirstServed: false,
		});
	};

	/**
	 * Determines whether the form is currently in a valid state to make an API request or not
	 * @returns {{ isValid : Boolean}} An object containing the property `isValid`
	 */
	validateForm = () => {
		const {
			timeToPost,
			postUsingAssignmentGroup,
			PostedType,
			PostedDelayType,
			postAt,
			postingTime,
			PostPriorByDays,
			AssignmentGroupId,
			StaggeredRuleId,
			PostedGroup,
			PostDelayInMinutes,
			PostByWeekDay,
			weekDayTime,
			daysPriorForWeek,
			PostByMonthDay,
			PostExactDateTime,
			monthDayTime,
			postExactTime,
			JobAutoAssignType,
			JobAutoAssignHoursSpan,
			JobAutoAssignJobCountDaysRadio,
			JobAutoAssignJobCountDaysSpan,
			postUsingStaggeredPosting,
			errors,
			_hoursJobsSelectedOptionValue,
			_limitToRoundsChecked,
			NumberOfRounds,
			setAssignmentRule,
			assignmentRuleName,
		} = this.state;
		let isValid = true;

		const {
			FIRST_COME_FIRST_SERVED,
			BY_HOURS,
			BY_JOBS,
			SENIORITY_DESCENDING,
			SENIORITY_ASCENDING,
			RANDOM,
			SENIORITY_DRAFT,
		} = AUTO_APPROVAL_TYPES;

		// Validate and ensure each field is not empty when toggled
		if (postUsingAssignmentGroup) {
			errors.AssignmentGroupId = AssignmentGroupId === "";
		} else {
			errors.AssignmentGroupId = false;
		}

		if (postUsingStaggeredPosting) {
			errors.StaggeredRuleId = StaggeredRuleId === "";
		} else {
			errors.StaggeredRuleId = false;
		}

		if (PostedType === 2) {
			errors.PostedGroup = PostedGroup === "";
		} else {
			errors.PostedGroup = false;
		}

		if (PostedDelayType === 1) {
			errors.PostDelayInMinutes = PostDelayInMinutes === "";
		} else {
			errors.PostDelayInMinutes = false;
		}

		if (timeToPost === "basedOnJob" && postAt === "PostPriorByDays") {
			errors.postingTime = !this.isTimeValid(postingTime);
			errors.PostPriorByDays = PostPriorByDays === "" || PostPriorByDays === "0";
		} else if (timeToPost === "basedOnJob" && postAt === "PostByWeekDay") {
			errors.PostByWeekDay = PostByWeekDay === "";
			errors.weekDayTime = !this.isTimeValid(weekDayTime);
			errors.daysPriorForWeek = daysPriorForWeek === "" || daysPriorForWeek === "0";
		} else if (timeToPost === "basedOnJob" && postAt === "PostByMonthDay") {
			errors.PostByMonthDay = PostByMonthDay === "" || PostByMonthDay === "0";
			errors.monthDayTime = !this.isTimeValid(monthDayTime);
		} else if (timeToPost === "specificDate" && postAt === "PostExactDateTime") {
			errors.PostExactDateTime = !errors.PostExactDateTime
				? PostExactDateTime === "" || PostExactDateTime === "0"
				: true;
			errors.postExactTime = !errors.postExactTime ? !this.isTimeValid(postExactTime) : true;
		} else {
			errors.postingTime = false;
			errors.PostPriorByDays = false;
			errors.PostByWeekDay = false;
			errors.PostPriorByDays = false;
			errors.weekDayTime = false;
			errors.daysPriorForWeek = false;
			errors.PostByMonthDay = false;
			errors.monthDayTime = false;
			errors.postExactTime = false;
			errors.PostExactDateTime = false;
		}

		// Officer Approval & Assignment Rules - HOURS, JOBS, SENIORITY(ASC,DESC) validation
		if (!postUsingAssignmentGroup && !postUsingStaggeredPosting) {
			if (
				[
					BY_HOURS,
					BY_JOBS,
					SENIORITY_DESCENDING,
					SENIORITY_ASCENDING,
					RANDOM,
					SENIORITY_DRAFT,
				].includes(JobAutoAssignType)
			) {
				errors.JobAutoAssignHoursSpan = utils.validateNumberInputRequired(
					JobAutoAssignHoursSpan,
					false,
				);
			} else {
				errors.JobAutoAssignHoursSpan = false;
			}
			if (
				(JobAutoAssignType === BY_HOURS || JobAutoAssignType === BY_JOBS) &&
				JobAutoAssignJobCountDaysRadio
			) {
				errors.JobAutoAssignJobCountDaysSpan = JobAutoAssignJobCountDaysSpan === "";
			}
		} else {
			errors.JobAutoAssignJobCountDaysSpan = false;
		}

		// Validate and ensure each field is not empty when toggled
		errors.assignmentRuleName = setAssignmentRule && assignmentRuleName.trim() === "";

		if (
			[
				FIRST_COME_FIRST_SERVED,
				SENIORITY_DESCENDING,
				SENIORITY_ASCENDING,
				SENIORITY_DRAFT,
			].includes(JobAutoAssignType)
		) {
			if (_limitToRoundsChecked) {
				errors.NumberOfRounds = utils.validateNumberInputRequired(NumberOfRounds, false);
			} else {
				errors.NumberOfRounds = false;
			}
		}
		// Seniority draft validation
		if (JobAutoAssignType === SENIORITY_DRAFT) {
			// _hoursJobsSelectedOptionValue, JobAutoAssignHoursSpan
			errors._hoursJobsSelectedOptionValue = utils.validateNumberInputRequired(
				_hoursJobsSelectedOptionValue,
				false,
			);
		}

		this.setState({ errors });

		isValid = Object.values(errors).filter(error => error === true).length === 0;
		return { isValid };
	};

	/**
	 * @param {String} time The time entered into the input field
	 * @returns {Boolean} Whether the format of the time is valid based on the current user's operating system
	 */
	isTimeValid = time => {
		// If time is blank, it is not valid
		if (time === "") {
			return false;
		}
		let timeRegex = /(\d{2}):(\d{2})/;
		if (utils.isDesktopSafari || utils.isIE) {
			timeRegex = /(\d{2}):(\d{2}) (A|P)M/i;
		}
		return timeRegex.test(time);
	};

	closeModal = () => {
		const { setAssignmentRule } = this.state;
		if (setAssignmentRule) this.setState({ setAssignmentRule: false });
		else {
			const {
				organization: {
					JobAutoAssignType = 1,
					JobAutoAssignJobCountDaysSpan = "",
					JobAutoAssignYearToDateSpan = false,
					JobAutoAssignRolling365 = false,
					JobAutoAssignJobCountDaysRadio = false,
				},
				closeModal,
			} = this.props;
			let {
				organization: { JobAutoAssignHoursSpan = "" },
			} = this.props;
			let signUpPeriodHoursMultiplier = 1;
			if (JobAutoAssignHoursSpan && JobAutoAssignHoursSpan % 24 === 0) {
				signUpPeriodHoursMultiplier = 24;
				JobAutoAssignHoursSpan = parseInt(JobAutoAssignHoursSpan, 10) / 24;
			}

			this.setState(
				{
					...this.initialState,
					signUpPeriodHoursMultiplier,
					JobAutoAssignHoursSpan,
					JobAutoAssignType,
					JobAutoAssignJobCountDaysSpan,
					JobAutoAssignYearToDateSpan,
					JobAutoAssignRolling365,
					JobAutoAssignJobCountDaysRadio,
				},
				() => {
					closeModal();
				},
			);
		}
	};

	render() {
		const { lang } = global;
		const {
			signUpPeriodHoursMultiplier,
			timeToPost,
			postAt,
			postUsingAssignmentGroup,
			postUsingStaggeredPosting,
			postingTime,
			AssignmentGroupId,
			StaggeredRuleId,
			daysPriorForWeek,
			monthDayTime,
			postExactTime,
			PostedType,
			PostedDelayType,
			OpenToAllOfficers,
			PostDelayInMinutes,
			PostedGroup,
			PostPriorByDays,
			weekDayTime,
			PostByWeekDay,
			PostByMonthDay,
			PostExactDateTime,
			JobAutoAssignType,
			JobAutoAssignHoursSpan,
			SeniorityOrder,
			JobAutoAssignYearToDateSpan,
			JobAutoAssignRolling365,
			JobAutoAssignJobCountDaysRadio,
			JobAutoAssignJobCountDaysSpan,
			assignmentGroups,
			staggeredRules,
			officerGroups,
			setAssignmentRule,
			assignmentRuleName,
			_hoursJobsSelectedOption,
			_limitToRoundsChecked,
			NumberOfRounds,
			EnableFirstComeFirstServed,
			errors,
			_hoursJobsSelectedOptionValue,
			AllowJobApplicationsWhileActive,
		} = this.state;
		const { show, selectedJobs, user } = this.props;

		const weekdays = DAYS_OF_WEEK.map(({ value, label }) => ({ value, label }));
		const dateMask = [/[0-1]/, /[0-9]/, "/", /[0-3]/, /[0-9]/, "/", /2/, /0/, /[2-9]/, /[0-9]/];
		const jobStartTime = utils.formatTime(
			new Date(`${selectedJobs[0]?.StartDateTime}Z`),
			true,
			selectedJobs[0]?.TimeZoneId,
		);
		const minStartDate = utils.formatDate();
		const maxStartDate =
			jobStartTime === "12:00 AM"
				? utils.formatDate(utils.addSubtractDate(selectedJobs[0]?.StartDateTime, 1, false))
				: utils.formatDate(
						new Date(`${selectedJobs[0]?.StartDateTime}Z`),
						undefined,
						selectedJobs[0]?.TimeZoneId,
					);
		const {
			FIRST_COME_FIRST_SERVED,
			MANUAL,
			SENIORITY_DESCENDING,
			SENIORITY_ASCENDING,
			SENIORITY_DRAFT,
			BY_HOURS,
			BY_JOBS,
			RANDOM,
		} = AUTO_APPROVAL_TYPES;
		const { MOST_SENIOR, LEAST_SENIOR } = ORDER_OF_SENIORITY;
		const timeLimit = utils.addSubtractTime(
			selectedJobs[0]?.StartDateTime,
			jobStartTime,
			15,
			false,
		);
		const maxTime = PostExactDateTime === maxStartDate ? timeLimit : undefined;
		const now = utils.formatTime(undefined, false, selectedJobs[0]?.TimeZoneId);
		const minTime = PostExactDateTime === minStartDate ? now : undefined;
		const isUnableToPostOnSpecificDate =
			selectedJobs[0]?.IsActive === true ||
			maxStartDate < minStartDate ||
			(maxStartDate === minStartDate && now > timeLimit);

		return (
			<Modal
				show={show}
				onHide={() => this.closeModal()}
				id="post-job-modal"
			>
				<Modal.Header closeButton>
					<Modal.Title>
						<Choose>
							<When condition={setAssignmentRule}>
								{lang.t("Create")} {lang.t("Assignment Rules")}
							</When>
							<Otherwise>{lang.t("Post Job")}</Otherwise>
						</Choose>
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{/* Post with Assignment Rule */}
					<div className="row">
						<br />
						<Choose>
							<When condition={setAssignmentRule}>
								<div className="col-xs-12">{lang.t("Assignment Rule Name")}</div>
								<div className="col-xs-12 col-sm-7">
									<div className="form-group">
										<input
											className={classNames("form-control", {
												"has-error": errors.assignmentRuleName,
											})}
											name="assignmentRuleName"
											value={assignmentRuleName}
											onChange={e => this.handleInputChange(e)}
										/>
									</div>
								</div>
							</When>
							<Otherwise>
								<div className="col-xs-12">{lang.t("Post with posting rule")}</div>
								<div className="col-xs-12">
									<div className="form-group">
										<div className="radio">
											<label htmlFor="postUsingAssignmentGroup-no">
												<input
													type="radio"
													name="postUsingAssignmentGroup"
													id="postUsingAssignmentGroup-no"
													data-test-id="jobs__post-using-assignment-group-no"
													value="false"
													checked={
														!postUsingAssignmentGroup &&
														!postUsingStaggeredPosting
													}
													onChange={e => this.handleRadioChange(e)}
												/>
												{lang.t("No")}
											</label>
										</div>
										<div className="radio">
											<label htmlFor="postUsingAssignmentGroup-yes">
												<input
													type="radio"
													name="postUsingAssignmentGroup"
													id="postUsingAssignmentGroup-yes"
													data-test-id="jobs__post-using-assignment-group-yes"
													value="true"
													checked={postUsingAssignmentGroup}
													onChange={e => this.handleRadioChange(e)}
												/>
												{lang.t("Use a single posting rule")}
											</label>
										</div>
										<div className="radio">
											<label htmlFor="postUsingStaggeredPosting-yes">
												<input
													type="radio"
													name="postUsingStaggeredPosting"
													id="postUsingStaggeredPosting-yes"
													data-test-id="jobs__post-using-staggered-posting-yes"
													value="true"
													checked={postUsingStaggeredPosting}
													onChange={e => this.handleRadioChange(e)}
												/>
												{lang.t("Use staggered posting")}
											</label>
										</div>
									</div>
								</div>
							</Otherwise>
						</Choose>
					</div>
					<Choose>
						<When condition={postUsingAssignmentGroup || postUsingStaggeredPosting}>
							<If condition={postUsingAssignmentGroup}>
								<div className="row">
									<div className="col-xs-12">
										<div
											className={classNames("form-group", {
												"has-error": errors.AssignmentGroupId,
											})}
										>
											<span>{lang.t("Posting Rule Name")}</span>
											<button
												type="button"
												id="add-new-group"
												data-test-id="jobs__add-new-group"
												className="btn btn-link"
												onClick={() => this.setAssignmentRule()}
											>
												{`+ ${lang.t("Create New Rule")}`}
											</button>
											<ReactSelect
												isClearable
												options={assignmentGroups}
												name="AssignmentGroupId"
												value={AssignmentGroupId}
												onChange={e =>
													this.handleInputChange(e, "AssignmentGroupId")
												}
												dataTestId="jobs__assignment-group-id"
											/>
										</div>
									</div>
								</div>
							</If>
							<If condition={postUsingStaggeredPosting}>
								<div className="row">
									<div className="col-xs-12">
										<div
											className={classNames("form-group", {
												"has-error": errors.AssignmentGroupId,
											})}
										>
											<span>{lang.t("Staggered Rule Name")}</span>
											<ReactSelect
												isClearable
												options={staggeredRules}
												name="StaggeredRuleId"
												value={StaggeredRuleId}
												onChange={e =>
													this.handleInputChange(e, "StaggeredRuleId")
												}
												dataTestId="jobs__staggered-rule-id"
											/>
										</div>
									</div>
								</div>
							</If>
						</When>
						<Otherwise>
							{/* Time to Consider */}
							<div className="row">
								<div
									className="col-xs-12"
									style={{ marginTop: "5px" }}
								>
									<div
										className={classNames("form-group", {
											"has-error": errors.AssignmentGroupId,
										})}
									>
										<span>{lang.t("Post Time")}</span>
										<ReactSelect
											options={this.timesToPost}
											name="timeToPost"
											value={timeToPost}
											onChange={e => this.handleInputChange(e, "timeToPost")}
											dataTestId="jobs__time-to-post"
										/>
									</div>
								</div>
								<div className="col-xs-12">
									<If condition={timeToPost === "basedOnJob"}>
										<div className="indent">
											<div className="radio radio-align">
												<label htmlFor="PostPriorByDays">
													<input
														type="radio"
														name="postAt"
														id="PostPriorByDays"
														value="PostPriorByDays"
														checked={postAt === "PostPriorByDays"}
														onChange={e => this.handleRadioChange(e)}
													/>
													{lang.t("Daily:")}
												</label>
											</div>
											<TimeInput
												name="postingTime"
												id="postingTime"
												time={postingTime}
												className={classNames("form-control", {
													"has-error": errors.postingTime,
												})}
												disabled={postAt !== "PostPriorByDays"}
												handleChange={e => this.handleInputChange(e)}
												user={user}
											/>
											<input
												type="tel"
												className={classNames("form-control", {
													"has-error": errors.PostPriorByDays,
												})}
												placeholder="eg: 2"
												name="PostPriorByDays"
												value={PostPriorByDays}
												disabled={postAt !== "PostPriorByDays"}
												onChange={e => this.handleInputChange(e)}
												onBlur={e => this.handleIntegerOnBlur(e)}
											/>
											<span>{lang.t("days prior to the job start_")}</span>
										</div>

										<div className="indent">
											<div className="radio radio-align">
												<label htmlFor="PostByWeek">
													<input
														type="radio"
														name="postAt"
														id="PostByWeek"
														value="PostByWeekDay"
														checked={postAt === "PostByWeekDay"}
														onChange={e => this.handleRadioChange(e)}
													/>
													{lang.t("Weekly:")}
												</label>
											</div>
											<select
												placeholder={lang.t("Select day")}
												className={classNames("form-control", {
													"has-error": errors.PostByWeekDay,
												})}
												name="PostByWeekDay"
												value={PostByWeekDay}
												disabled={postAt !== "PostByWeekDay"}
												onChange={e => this.handleInputChange(e)}
											>
												<option value="">
													{lang.t("Select a week day")}
												</option>
												<For
													each="item"
													of={weekdays}
													index="index"
												>
													<option
														key={`PostByWeekDay_days${index}_${item.value}`}
														value={item.value}
													>
														{item.label}
													</option>
												</For>
											</select>
											<span>{lang.t("At")}</span>
											<TimeInput
												name="weekDayTime"
												id="weekDayTime"
												time={weekDayTime}
												className={classNames("form-control", {
													"has-error": errors.weekDayTime,
												})}
												disabled={postAt !== "PostByWeekDay"}
												handleChange={e => this.handleInputChange(e)}
												user={user}
											/>
											<input
												className={classNames("form-control", {
													"has-error": errors.daysPriorForWeek,
												})}
												type="tel"
												placeholder="eg: 2"
												name="daysPriorForWeek"
												value={daysPriorForWeek}
												disabled={postAt !== "PostByWeekDay"}
												onChange={e => this.handleInputChange(e)}
												onBlur={e => this.handleIntegerOnBlur(e)}
											/>
											<span>{lang.t("days prior to the job start_")}</span>
										</div>

										<div className="indent">
											<div className="radio radio-align">
												<label htmlFor="PostByMonth">
													<input
														type="radio"
														name="postAt"
														id="PostByMonth"
														value="PostByMonthDay"
														checked={postAt === "PostByMonthDay"}
														onChange={e => this.handleRadioChange(e)}
													/>
													{lang.t("Monthly:")}
												</label>
											</div>
											<input
												name="PostByMonthDay"
												id="PostByMonthDay"
												className={classNames("form-control", {
													"has-error": errors.PostByMonthDay,
												})}
												type="tel"
												value={PostByMonthDay}
												disabled={postAt !== "PostByMonthDay"}
												onChange={e => this.handleInputChange(e)}
												onBlur={e => this.handleIntegerOnBlur(e)}
											/>
											<span>{lang.t("day of month at")}</span>
											<TimeInput
												name="monthDayTime"
												id="monthDayTime"
												time={monthDayTime}
												className={classNames("form-control", {
													"has-error": errors.monthDayTime,
												})}
												disabled={postAt !== "PostByMonthDay"}
												handleChange={e => this.handleInputChange(e)}
												user={user}
											/>
											<span>{lang.t("all of next month jobs_")}</span>
										</div>
									</If>
									<If condition={timeToPost === "specificDate"}>
										<div
											className="indent date-select-container"
											title={
												isUnableToPostOnSpecificDate
													? lang.t(
															"The current job is already active or ended",
														)
													: ""
											}
										>
											<div className="radio radio-align">
												<label htmlFor="PostExactDateTime">
													<input
														type="radio"
														name="postAt"
														id="PostExactDateTime"
														value="PostExactDateTime"
														checked={postAt === "PostExactDateTime"}
														onChange={e => this.handleRadioChange(e)}
														disabled={isUnableToPostOnSpecificDate}
													/>
													{lang.t("Post on")}
												</label>
											</div>
											<Choose>
												<When
													condition={utils.isDesktopSafari || utils.isIE}
												>
													<MaskedInput
														name="PostExactDateTime"
														type="text"
														mask={dateMask}
														className={classNames(
															"form-control",
															"date-select",
															{
																"has-error":
																	errors.PostExactDateTime,
															},
														)}
														placeholder="mm/dd/yyyy"
														min={minStartDate}
														max={
															setAssignmentRule
																? undefined
																: maxStartDate
														}
														value={PostExactDateTime}
														disabled={postAt !== "PostExactDateTime"}
														onChange={this.changeDate(
															"PostExactDateTime",
														)}
													/>
												</When>
												<Otherwise>
													<input
														name="PostExactDateTime"
														className={classNames(
															"form-control",
															"date-select",
															{
																"has-error":
																	errors.PostExactDateTime,
															},
														)}
														type="date"
														min={minStartDate}
														max={
															setAssignmentRule
																? undefined
																: maxStartDate
														}
														value={PostExactDateTime}
														disabled={postAt !== "PostExactDateTime"}
														onChange={this.changeDate(
															"PostExactDateTime",
														)}
													/>
												</Otherwise>
											</Choose>
											<span>{lang.t("At")}</span>
											<TimeInput
												name="postExactTime"
												id="postExactTime"
												time={postExactTime}
												className={classNames("form-control", {
													"has-error": errors.postExactTime,
												})}
												min={minTime}
												max={setAssignmentRule ? undefined : maxTime}
												disabled={
													postAt !== "PostExactDateTime" ||
													!PostExactDateTime
												}
												handleChange={e => this.handleInputChange(e)}
												user={user}
											/>
										</div>
									</If>
								</div>
							</div>
							<If
								condition={
									timeToPost === "specificDate" || timeToPost === "basedOnJob"
								}
							>
								<div className="separator separator-solid" />
							</If>
							<div className="row">
								<div className="col-xs-12">
									<div
										className={classNames("form-group", {
											"has-error": errors.AssignmentGroupId,
										})}
									>
										<span>{lang.t("Viewing group (audience)")}</span>
										<ReactSelect
											options={officerGroups}
											name="PostedGroup"
											value={PostedGroup}
											onChange={e => this.handleInputChange(e, "PostedGroup")}
											dataTestId="jobs__posted-group"
										/>
									</div>
								</div>
								<div className="col-xs-12">
									<If condition={PostedType === 2}>
										<div>
											<label htmlFor="OpenToAllOfficers">
												<input
													style={{ marginRight: "8px" }}
													type="checkbox"
													name="OpenToAllOfficers"
													id="OpenToAllOfficers"
													checked={OpenToAllOfficers}
													value={OpenToAllOfficers}
													onChange={e =>
														this.handleInputChange(
															e,
															"OpenToAllOfficers",
														)
													}
													onClick={e =>
														this.handleInputChange(
															e,
															"OpenToAllOfficers",
														)
													}
												/>
												{`${lang.t("Open to all officers")}`}
												<Tooltip
													content={`${lang.t("If this option is selected, you can post to a specific group then delay posting to the whole department with the two options below")}`}
												>
													<i className="rkf rkf-question-solid tooltip-icon hidden-xs" />
												</Tooltip>
											</label>
										</div>
										<If condition={OpenToAllOfficers}>
											<div style={{ marginLeft: "8px" }}>
												<div className="radio radio-align">
													<label htmlFor="PostedDelayType-variable">
														<input
															type="radio"
															name="PostedDelayType"
															id="PostedDelayType-variable"
															value={1}
															checked={PostedDelayType === 1}
															onChange={e =>
																this.handleRadioChange(e)
															}
														/>
														<span>{lang.t("After")}</span>
													</label>
												</div>
												<input
													type="tel"
													name="PostDelayInMinutes"
													className={classNames("form-control", {
														"has-error": errors.PostDelayInMinutes,
													})}
													placeholder="eg: 2"
													disabled={PostedDelayType !== 1}
													value={PostDelayInMinutes}
													onChange={e => this.handleInputChange(e)}
													onBlur={e => this.handleIntegerOnBlur(e)}
												/>
												<span>{lang.t("Hours")}</span>
												<div className="radio">
													<label htmlFor="PostedDelayType-static">
														<input
															type="radio"
															name="PostedDelayType"
															id="PostedDelayType-static"
															value="2"
															checked={PostedDelayType === 2}
															onChange={e =>
																this.handleRadioChange(e)
															}
														/>
														{lang.t("If not filled")}{" "}
														<strong>
															{lang.t("48 hours before job start_")}
														</strong>
													</label>
												</div>
											</div>
										</If>
									</If>
								</div>
							</div>
							{/* Post with Assignment Rule */}

							{/* Officer Approval & Assignment Rules */}
							<If condition={PostedType === 2}>
								<div className="separator separator-solid" />
							</If>
							<div className="row">
								<div className="col-xs-12">
									<div
										className={classNames("form-group", {
											"has-error": errors.AssignmentGroupId,
										})}
									>
										<span>{lang.t("Assignment Type")}</span>
										<ReactSelect
											options={this.assignmentTypes}
											name="JobAutoAssignType"
											value={JobAutoAssignType}
											onChange={e =>
												this.handleInputChange(e, "JobAutoAssignType")
											}
											dataTestId="jobs__assignment-type"
										/>
									</div>
									<If condition={JobAutoAssignType === BY_HOURS}>
										<div className="indent">
											<span>{lang.t("Sign-Up Period")}:</span>
											<input
												className={classNames("form-control", {
													"has-error": errors.JobAutoAssignHoursSpan,
												})}
												type="tel"
												placeholder="eg: 2"
												name="JobAutoAssignHoursSpan"
												value={JobAutoAssignHoursSpan}
												onChange={e => this.handleInputChange(e)}
												onBlur={e => this.handleIntegerOnBlur(e)}
											/>
											<select
												name="signUpPeriodHoursMultiplier"
												className="form-control"
												placeholder={lang.t("Hours or days_")}
												value={signUpPeriodHoursMultiplier}
												onChange={e => this.handleInputChange(e)}
											>
												<For
													each="item"
													of={this.signUpPeriodTimeTypeOptions}
													index="index"
												>
													<option
														key={`signUpPeriod_byHours${index}_${item.value}`}
														value={item.value}
													>
														{item.label}
													</option>
												</For>
											</select>
											<div>{lang.t("Time to Consider")}:</div>
											<div className="radio radio-align">
												<label htmlFor="JobAutoAssignJobCountDaysRadio-byHours">
													<input
														type="radio"
														name="JobAutoAssignYearToDateSpan"
														id="JobAutoAssignJobCountDaysRadio-byHours"
														checked={JobAutoAssignJobCountDaysRadio}
														value="true"
														onChange={e => this.handleRadioChange(e)}
													/>
												</label>
											</div>
											<input
												className={classNames("form-control", {
													"has-error":
														errors.JobAutoAssignJobCountDaysSpan,
												})}
												type="tel"
												placeholder="eg: 2"
												name="JobAutoAssignJobCountDaysSpan"
												value={JobAutoAssignJobCountDaysSpan}
												disabled={!JobAutoAssignJobCountDaysRadio}
												onChange={e => this.handleInputChange(e)}
												onBlur={e => this.handleIntegerOnBlur(e)}
											/>
											<span>{lang.t("days")}</span>
											<div className="radio">
												<label htmlFor="JobAutoAssignYearToDateSpan-toDate">
													<input
														type="radio"
														name="JobAutoAssignYearToDateSpan"
														id="JobAutoAssignYearToDateSpan-toDate"
														checked={JobAutoAssignYearToDateSpan}
														value="true"
														onChange={e => this.handleRadioChange(e)}
													/>
													<span>{lang.t("Year to Date")}</span>
												</label>
											</div>
											<div className="radio">
												<label htmlFor="JobAutoAssignRolling365-toDate">
													<input
														type="radio"
														name="JobAutoAssignYearToDateSpan"
														id="JobAutoAssignRolling365-toDate"
														checked={JobAutoAssignRolling365}
														value="true"
														onChange={e => this.handleRadioChange(e)}
													/>
													<span>{lang.t("Rolling 365")}</span>
												</label>
											</div>
										</div>
									</If>
									<If condition={JobAutoAssignType === BY_JOBS}>
										<div className="indent">
											<span>{lang.t("Sign-Up Period")}:</span>
											<input
												className={classNames("form-control", {
													"has-error": errors.JobAutoAssignHoursSpan,
												})}
												type="tel"
												placeholder="eg: 2"
												name="JobAutoAssignHoursSpan"
												value={JobAutoAssignHoursSpan}
												onChange={e => this.handleInputChange(e)}
												onBlur={e => this.handleIntegerOnBlur(e)}
											/>
											<select
												name="signUpPeriodHoursMultiplier"
												className="form-control"
												placeholder={lang.t("Hours or days_")}
												value={signUpPeriodHoursMultiplier}
												onChange={e => this.handleInputChange(e)}
											>
												<For
													each="item"
													of={this.signUpPeriodTimeTypeOptions}
													index="index"
												>
													<option
														key={`signUpPeriod_byHours${index}_${item.value}`}
														value={item.value}
													>
														{item.label}
													</option>
												</For>
											</select>
											<div>{lang.t("Time to Consider")}:</div>
											<div className="radio radio-align">
												<label htmlFor="JobAutoAssignJobCountDaysRadio-byHours">
													<input
														type="radio"
														name="JobAutoAssignYearToDateSpan"
														id="JobAutoAssignJobCountDaysRadio-byHours"
														checked={JobAutoAssignJobCountDaysRadio}
														value="true"
														onChange={e => this.handleRadioChange(e)}
													/>
												</label>
											</div>
											<input
												className={classNames("form-control", {
													"has-error":
														errors.JobAutoAssignJobCountDaysSpan,
												})}
												type="tel"
												placeholder="eg: 2"
												name="JobAutoAssignJobCountDaysSpan"
												value={JobAutoAssignJobCountDaysSpan}
												disabled={!JobAutoAssignJobCountDaysRadio}
												onChange={e => this.handleInputChange(e)}
												onBlur={e => this.handleIntegerOnBlur(e)}
											/>
											<span>{lang.t("days")}</span>
											<div className="radio">
												<label htmlFor="JobAutoAssignYearToDateSpan-toDate">
													<input
														type="radio"
														name="JobAutoAssignYearToDateSpan"
														id="JobAutoAssignYearToDateSpan-toDate"
														checked={JobAutoAssignYearToDateSpan}
														value="true"
														onChange={e => this.handleRadioChange(e)}
													/>
													<span>{lang.t("Year to Date")}</span>
												</label>
											</div>
											<div className="radio">
												<label htmlFor="JobAutoAssignRolling365-toDate">
													<input
														type="radio"
														name="JobAutoAssignYearToDateSpan"
														id="JobAutoAssignRolling365-toDate"
														checked={JobAutoAssignRolling365}
														value="true"
														onChange={e => this.handleRadioChange(e)}
													/>
													<span>{lang.t("Rolling 365")}</span>
												</label>
											</div>
										</div>
									</If>
									<If condition={JobAutoAssignType === SENIORITY_DESCENDING}>
										<div className="indent">
											<span>{lang.t("Sign-Up Period")}:</span>
											<input
												className={classNames("form-control", {
													"has-error": errors.JobAutoAssignHoursSpan,
												})}
												type="tel"
												placeholder="eg: 2"
												name="JobAutoAssignHoursSpan"
												value={JobAutoAssignHoursSpan}
												onChange={e => this.handleInputChange(e)}
												onBlur={e => this.handleIntegerOnBlur(e)}
											/>
											<select
												name="signUpPeriodHoursMultiplier"
												className="form-control"
												placeholder={lang.t("Hours or days_")}
												value={signUpPeriodHoursMultiplier}
												onChange={e => this.handleInputChange(e)}
											>
												<For
													each="item"
													of={this.signUpPeriodTimeTypeOptions}
													index="index"
												>
													<option
														key={`signUpPeriod_byHours${index}_${item.value}`}
														value={item.value}
													>
														{item.label}
													</option>
												</For>
											</select>
											<If condition={setAssignmentRule}>
												<div>
													<label htmlFor="assign-limit-to-rounds">
														<input
															type="checkbox"
															name="_limitToRoundsChecked"
															id="assign-limit-to-rounds"
															checked={_limitToRoundsChecked}
															value={_limitToRoundsChecked}
															onChange={e =>
																this.handleInputChange(e)
															}
															onClick={e => this.handleInputChange(e)}
														/>
														{`${lang.t("Limit to")}:`}
													</label>
													<input
														type="tel"
														min="0"
														id="assign-hours-max-rounds"
														name="NumberOfRounds"
														className={classNames("form-control", {
															"has-error": errors.NumberOfRounds,
														})}
														placeholder="eg: 2"
														value={NumberOfRounds}
														disabled={!_limitToRoundsChecked}
														onChange={e => this.handleInputChange(e)}
													/>
													{lang.t("max rounds")}
												</div>
											</If>
										</div>
									</If>
									<If condition={JobAutoAssignType === SENIORITY_ASCENDING}>
										<div className="indent">
											<span>{lang.t("Sign-Up Period")}:</span>
											<input
												className={classNames("form-control", {
													"has-error": errors.JobAutoAssignHoursSpan,
												})}
												type="tel"
												placeholder="eg: 2"
												name="JobAutoAssignHoursSpan"
												value={JobAutoAssignHoursSpan}
												onChange={e => this.handleInputChange(e)}
												onBlur={e => this.handleIntegerOnBlur(e)}
											/>
											<select
												name="signUpPeriodHoursMultiplier"
												className="form-control"
												placeholder={lang.t("Hours or days_")}
												value={signUpPeriodHoursMultiplier}
												onChange={e => this.handleInputChange(e)}
											>
												<For
													each="item"
													of={this.signUpPeriodTimeTypeOptions}
													index="index"
												>
													<option
														key={`signUpPeriod_byHours${index}_${item.value}`}
														value={item.value}
													>
														{item.label}
													</option>
												</For>
											</select>
											<If condition={setAssignmentRule}>
												<div>
													<label htmlFor="assign-limit-to-rounds">
														<input
															type="checkbox"
															name="_limitToRoundsChecked"
															id="assign-limit-to-rounds"
															checked={_limitToRoundsChecked}
															value={_limitToRoundsChecked}
															onChange={e =>
																this.handleInputChange(e)
															}
															onClick={e => this.handleInputChange(e)}
														/>
														{`${lang.t("Limit to")}:`}
													</label>
													<input
														type="tel"
														min="0"
														id="assign-hours-max-rounds"
														name="NumberOfRounds"
														className={classNames("form-control", {
															"has-error": errors.NumberOfRounds,
														})}
														placeholder="eg: 2"
														value={NumberOfRounds}
														disabled={!_limitToRoundsChecked}
														onChange={e => this.handleInputChange(e)}
													/>
													{lang.t("max rounds")}
												</div>
											</If>
										</div>
									</If>
									{/* TODO: remove utils.isOrganizationEnabled(organization.Id) when the seniority draft will be released to all departments */}
									<If
										condition={
											JobAutoAssignType === SENIORITY_DRAFT &&
											setAssignmentRule
										}
									>
										<div className="indent">
											<div>
												<span>{`${lang.t("Sort by")}:`}</span>
												<select
													id="seniority-order"
													name="SeniorityOrder"
													className="form-control"
													value={SeniorityOrder}
													onChange={e => this.handleInputChange(e)}
												>
													<option value={MOST_SENIOR}>
														{lang.t("Most senior")}
													</option>
													<option value={LEAST_SENIOR}>
														{lang.t("Least senior")}
													</option>
												</select>
											</div>
											<div>
												<span>{lang.t("Sign-Up Period")}:</span>
												<input
													className={classNames("form-control", {
														"has-error": errors.JobAutoAssignHoursSpan,
													})}
													type="tel"
													placeholder="eg: 2"
													name="JobAutoAssignHoursSpan"
													value={JobAutoAssignHoursSpan}
													onChange={e => this.handleInputChange(e)}
													onBlur={e => this.handleIntegerOnBlur(e)}
												/>
												<select
													name="signUpPeriodHoursMultiplier"
													className="form-control"
													placeholder={lang.t("Hours or days_")}
													value={signUpPeriodHoursMultiplier}
													onChange={e => this.handleInputChange(e)}
												>
													<For
														each="item"
														of={this.signUpPeriodTimeTypeOptions}
														index="index"
													>
														<option
															key={`signUpPeriod_${index}_${item.value}`}
															value={item.value}
														>
															{item.label}
														</option>
													</For>
												</select>
											</div>
											<div>
												{lang.t("With")}:
												<input
													className={classNames("form-control", {
														"has-error":
															errors._hoursJobsSelectedOptionValue,
													})}
													type="tel"
													placeholder="eg: 2"
													name="_hoursJobsSelectedOptionValue"
													value={_hoursJobsSelectedOptionValue}
													onChange={e => this.handleInputChange(e)}
													onBlur={e => this.handleIntegerOnBlur(e)}
												/>
												<select
													id="assign-hours-multiplier"
													name="_hoursJobsSelectedOption"
													className="form-control"
													value={_hoursJobsSelectedOption}
													onChange={e => this.handleInputChange(e)}
												>
													<option value="MaxHoursAssignmentPerCycle">
														{lang.t("Hours")}
													</option>
													<option value="JobAutoAssignQueueCycleMaxAssignments">
														{lang.t("Jobs")}
													</option>
												</select>
												{lang.t("per officer per round")}
											</div>
											<div>
												<label htmlFor="assign-limit-to-rounds">
													<input
														type="checkbox"
														name="_limitToRoundsChecked"
														id="assign-limit-to-rounds"
														checked={_limitToRoundsChecked}
														value={_limitToRoundsChecked}
														onChange={e => this.handleInputChange(e)}
														onClick={e => this.handleInputChange(e)}
													/>
													{`${lang.t("Limit to")}:`}
												</label>
												<input
													type="tel"
													min="0"
													id="assign-hours-max-rounds"
													name="NumberOfRounds"
													className={classNames("form-control", {
														"has-error": errors.NumberOfRounds,
													})}
													placeholder="eg: 2"
													value={NumberOfRounds}
													disabled={!_limitToRoundsChecked}
													onChange={e => this.handleInputChange(e)}
												/>
												{lang.t("max rounds")}
											</div>
										</div>
									</If>
									<If condition={JobAutoAssignType === RANDOM}>
										<div className="indent">
											<span>{lang.t("Sign-Up Period")}:</span>
											<input
												className={classNames("form-control", {
													"has-error": errors.JobAutoAssignHoursSpan,
												})}
												type="tel"
												placeholder="eg: 2"
												name="JobAutoAssignHoursSpan"
												value={JobAutoAssignHoursSpan}
												onChange={e => this.handleInputChange(e)}
												onBlur={e => this.handleIntegerOnBlur(e)}
											/>
											<select
												name="signUpPeriodHoursMultiplier"
												className="form-control"
												placeholder={lang.t("Hours or days_")}
												value={signUpPeriodHoursMultiplier}
												onChange={e => this.handleInputChange(e)}
											>
												<For
													each="item"
													of={this.signUpPeriodTimeTypeOptions}
													index="index"
												>
													<option
														key={`signUpPeriod_byHours${index}_${item.value}`}
														value={item.value}
													>
														{item.label}
													</option>
												</For>
											</select>
										</div>
									</If>
								</div>
							</div>
							{/* Officer Approval & Assignment Rules */}
						</Otherwise>
					</Choose>
					<If
						condition={
							JobAutoAssignType !== MANUAL &&
							JobAutoAssignType !== FIRST_COME_FIRST_SERVED &&
							!postUsingStaggeredPosting &&
							!postUsingAssignmentGroup
						}
					>
						<div className="separator separator-solid" />
						<div className="row">
							<div className="col-xs-12">
								<label
									htmlFor="enable-fist-come-first-served"
									className="fcfs-label"
								>
									<input
										style={{ marginRight: "8px" }}
										type="checkbox"
										name="EnableFirstComeFirstServed"
										id="enable-fist-come-first-served"
										checked={EnableFirstComeFirstServed}
										value={EnableFirstComeFirstServed}
										onChange={e => this.handleInputChange(e)}
										onClick={e => this.handleInputChange(e)}
									/>
									{`${lang.t("After sign up period has expired, post job as first come first serve to whole department")}`}
									<Tooltip
										content={`${lang.t("If this option is not selected the job will unpost at the end of the sign up period, which may affect call off options_")},
										 ${lang.t("If you would like to post First come first serve to a specific group, try building a staggered rule set_")}`}
									>
										<i className="rkf rkf-question-solid tooltip-icon hidden-xs" />
									</Tooltip>
								</label>
							</div>
						</div>
					</If>
					<If
						condition={
							user.KeepJobsPosted &&
							!postUsingStaggeredPosting &&
							(JobAutoAssignType === MANUAL ||
								JobAutoAssignType === FIRST_COME_FIRST_SERVED ||
								EnableFirstComeFirstServed) &&
							!setAssignmentRule &&
							(!postUsingAssignmentGroup ||
								(postUsingAssignmentGroup &&
									assignmentGroups?.find(item => AssignmentGroupId === item.value)
										?.KeepOriginalBehaviorForAutoAssign))
						}
					>
						<div className="row">
							<div className="col-xs-12">
								<label htmlFor="allow-job-applications-while-active">
									<input
										style={{ marginRight: "8px" }}
										type="checkbox"
										name="AllowJobApplicationsWhileActive"
										id="allow-job-applications-while-active"
										checked={AllowJobApplicationsWhileActive}
										value={AllowJobApplicationsWhileActive}
										onChange={e => this.handleInputChange(e)}
										onClick={e => this.handleInputChange(e)}
									/>
									{`${lang.t("Allow officers to apply while the job is active")}`}
								</label>
							</div>
						</div>
					</If>
				</Modal.Body>
				<Modal.Footer>
					<button
						id="btn-close-modal"
						className="btn btn-link"
						type="button"
						onClick={() => this.closeModal()}
					>
						{lang.t("Close")}
					</button>
					<button
						id="btn-post-job"
						className="btn btn-primary"
						type="button"
						onClick={setAssignmentRule ? this.onSaveAssigmentRule : this.postJob}
					>
						{setAssignmentRule ? lang.t("Save") : lang.t("Post")}
					</button>
				</Modal.Footer>
			</Modal>
		);
	}
}

PostJobModal.propTypes = {
	show: PropTypes.bool.isRequired,
	updateAllUpcoming: PropTypes.bool.isRequired,
	closeModal: PropTypes.func.isRequired,
	selectedJobs: PropTypes.array.isRequired,
	organization: PropTypes.object,
	successCallback: PropTypes.func,
	user: PropTypes.object,
};

PostJobModal.defaultProps = {
	organization: {},
	user: {},
	successCallback: () => {},
};

export default PostJobModal;
